import React from 'react';
import { PageHero } from '../components/PageHero';
export function NotFoundPage() {
  return <PageHero crumbs={[{
    label: 'Page not found'
  }]} title={<>
          Page <span className="text-brand" data-id="element-504" data-mp="105d01zado35g">not found</span>
        </>} intro="We couldn’t find that page. Use the menu above to find a service, or send us a quick quote request." data-id="element-503" data-mp="w3rgjv3c8qma" />;
}